"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.functionCall = exports.isBinaryOperator = exports.isUnaryOperator = exports.mapBuiltinName = exports.mappedBuiltinNames = void 0;
const builtins_1 = require("../../builtins");
const builtinTranspileConfig = {
    [builtins_1.BuiltinName.Add]: binaryExpression('+'),
    [builtins_1.BuiltinName.Subtract]: binaryExpression('-'),
    [builtins_1.BuiltinName.Multiply]: binaryExpression('*'),
    [builtins_1.BuiltinName.Divide]: binaryExpression('/'),
    [builtins_1.BuiltinName.Modulus]: binaryExpression('%'),
    [builtins_1.BuiltinName.LessThan]: binaryExpression('<'),
    [builtins_1.BuiltinName.LessEqualThan]: binaryExpression('<='),
    [builtins_1.BuiltinName.GreaterThan]: binaryExpression('>'),
    [builtins_1.BuiltinName.GreaterEqualThan]: binaryExpression('>='),
    [builtins_1.BuiltinName.Equal]: binaryExpression('==='),
    [builtins_1.BuiltinName.NotEqual]: binaryExpression('!=='),
    [builtins_1.BuiltinName.And]: binaryExpression('&&'),
    [builtins_1.BuiltinName.Or]: binaryExpression('||'),
    [builtins_1.BuiltinName.Not]: unaryExpression('!'),
    [builtins_1.BuiltinName.Tuple2]: functionCall('makeTuple2'),
    [builtins_1.BuiltinName.Tuple3]: functionCall('makeTuple3'),
    [builtins_1.BuiltinName.Tuple4]: functionCall('makeTuple4'),
    [builtins_1.BuiltinName.Tuple5]: functionCall('makeTuple5'),
    [builtins_1.BuiltinName.Compose]: functionCall('compose'),
    [builtins_1.BuiltinName.Pipe]: functionCall('pipe'),
    [builtins_1.BuiltinName.Identity]: functionCall('id'),
    [builtins_1.BuiltinName.Constant]: functionCall('constant'),
    [builtins_1.BuiltinName.EqualPolymorphic]: functionCall('eq'),
    [builtins_1.BuiltinName.ToString]: functionCall('toString'),
    [builtins_1.BuiltinName.SquareRoot]: functionCall('sqrt'),
    [builtins_1.BuiltinName.Floor]: functionCall('floor'),
    [builtins_1.BuiltinName.Ceil]: functionCall('ceil'),
    [builtins_1.BuiltinName.First]: functionCall('first'),
    [builtins_1.BuiltinName.Second]: functionCall('second'),
    [builtins_1.BuiltinName.ExtendArray]: functionCall('extend'),
    [builtins_1.BuiltinName.Head]: functionCall('head'),
    [builtins_1.BuiltinName.Tail]: functionCall('tail'),
    [builtins_1.BuiltinName.IsEmpty]: functionCall('isEmpty'),
    [builtins_1.BuiltinName.Concat]: functionCall('concat'),
    [builtins_1.BuiltinName.Map]: functionCall('map'),
    [builtins_1.BuiltinName.Filter]: functionCall('filter'),
    [builtins_1.BuiltinName.Reduce]: functionCall('reduce'),
    [builtins_1.BuiltinName.Reduce0]: functionCall('reduce0'),
    [builtins_1.BuiltinName.Join]: functionCall('join'),
    [builtins_1.BuiltinName.Length]: functionCall('length'),
    [builtins_1.BuiltinName.ToLower]: functionCall('lower'),
    [builtins_1.BuiltinName.ToUpper]: functionCall('upper'),
};
exports.mappedBuiltinNames = new Set(Object.values(builtinTranspileConfig).map(config => config.name));
function mapBuiltinName(name) {
    return builtinTranspileConfig[name].name;
}
exports.mapBuiltinName = mapBuiltinName;
function isUnaryOperator(identifier) {
    return unaryNames.has(identifier);
}
exports.isUnaryOperator = isUnaryOperator;
function isBinaryOperator(identifier) {
    return binaryNames.has(identifier);
}
exports.isBinaryOperator = isBinaryOperator;
function getNames(transpileOption) {
    const keys = Object.keys(builtinTranspileConfig).filter(key => builtinTranspileConfig[key].transpileAs === transpileOption);
    return new Set(keys);
}
function functionCall(name) {
    return {
        transpileAs: "FunctionCall",
        name,
    };
}
exports.functionCall = functionCall;
var TranspileOption;
(function (TranspileOption) {
    TranspileOption["BinaryExpression"] = "BinaryExpression";
    TranspileOption["UnaryExpression"] = "UnaryExpression";
    TranspileOption["FunctionCall"] = "FunctionCall";
})(TranspileOption || (TranspileOption = {}));
function unaryExpression(name) {
    return {
        transpileAs: "UnaryExpression",
        name,
    };
}
function binaryExpression(name) {
    return {
        transpileAs: "BinaryExpression",
        name,
    };
}
const unaryNames = getNames("UnaryExpression");
const binaryNames = getNames("BinaryExpression");
//# sourceMappingURL=builtins.js.map